import { axiosInstance } from '../api';

export default function(fhirId) {
    return axiosInstance.get(`/fhir/ResearchStudy/$interestedStudies?_id=${fhirId}`);
}